<script setup>

import { inject, computed } from 'vue'

import Listbox from 'primevue/listbox';
import Champ from './Champ.vue'

const emit = defineEmits(['creationChamp']);

const { typeObjet } = defineProps({
  typeObjet: Object
})

const selectionSchema = inject('selectionSchema');
const getDimension = inject('getDimension');

const champsGroupes = computed(() => {
	if (typeObjet) {
		let champsGroupes = new Map();
		let listeChamps;
		let cleChamp;
		if (typeObjet.population) {
			champsGroupes.set('POPULATION', typeObjet.population);
		}
		for (const champ of typeObjet.champs) {
			if (champ.modeEvaluation.startsWith('CLE')) {
				cleChamp = 'CLES';
			} else if (champ.typeDonnee.classe === 'OBJET') {
				cleChamp = 'LIENS';
			} else {
				cleChamp = JSON.stringify(champ.dimensions);
			}
			if (champsGroupes.has(cleChamp)) {
				listeChamps = champsGroupes.get(cleChamp);
			} else {
				listeChamps = [];
				champsGroupes.set(cleChamp, listeChamps);
			}
			listeChamps.push(champ);
		}
		return champsGroupes;
	} else {
		return null;
	}
});

const champsTries = computed(() => {
	var champsTries = [];
	if (champsGroupes.value) {
		if (champsGroupes.value.has('POPULATION')) {
			champsTries.push({libelleGroupe: 'Population'});
			champsTries.push(champsGroupes.value.get('POPULATION'));
		}
		if (champsGroupes.value.has('CLES')) {
			champsTries.push({libelleGroupe: 'Clé(s)'});
			champsTries.push(...champsGroupes.value.get('CLES').toSorted(comparerChamps));
		}
		if (champsGroupes.value.has('LIENS')) {
			champsTries.push({libelleGroupe: 'Lien(s)'});
			champsTries.push(...champsGroupes.value.get('LIENS').toSorted(comparerChamps));
		}
		if (champsGroupes.value.has('[]')) {
			champsTries.push({libelleGroupe: 'Valeurs sans dimension'});
			champsTries.push(...champsGroupes.value.get('[]').toSorted(comparerChamps));
		}
		for (const [cleDimensions, listeChamps] of champsGroupes.value) {
			if (!['POPULATION', 'CLES', 'LIENS', '[]'].includes(cleDimensions)) {
				let descDimensions = JSON.parse(cleDimensions).map(idDimension => getDimension(idDimension).nom).join(', ');
				champsTries.push({libelleGroupe: `Valeurs de dimension(s) : ${descDimensions}`});
				champsTries.push(...listeChamps.toSorted(comparerChamps));
			}
		}
		return champsTries;
	}
	return champsTries;
});

function comparerChamps(champ1, champ2) {
	return champ1.nom.localeCompare(champ2.nom);
}

function selectionnerPlageChamps(champ) {
	const nbChampsSelectionnes = selectionSchema.value.champs.length;
	if (nbChampsSelectionnes > 0) {
		const dernierChampSelectionne = selectionSchema.value.champs[nbChampsSelectionnes - 1];
		const indiceDernierChampSelectionne = champsTries.value.indexOf(dernierChampSelectionne);
		const indiceChamp = champsTries.value.indexOf(champ);
		if (indiceDernierChampSelectionne === indiceChamp) {
			return;
		}
		const increment = indiceDernierChampSelectionne < indiceChamp ? 1 : -1;
		for (var indice = indiceDernierChampSelectionne + increment; indice !== indiceChamp + increment; indice+= increment) {
			selectionSchema.value.champs.push(champsTries.value[indice]);
		}
	} else {
		selectionSchema.value.champs = [champ];
	}
}

function afficherModaleAjoutChamp() {
	emit('creationChamp', typeObjet);
}


</script>

<template>
	<div v-if="typeObjet != null">
		<div class="entete">
			<label class="titre">{{ typeObjet.population ? 'Population et champs' : 'Champs' }}</label>
			<button class="bouton fa-solid fa-plus" @click="afficherModaleAjoutChamp()" />
		</div>
		<Listbox class="liste-champs" 
			multiple
			metaKeySelection
			v-model="selectionSchema.champs" 
			:options="champsTries"
			:selectOnFocus="true"
			:emptyMessage="'Aucun champ'"
			:optionLabel="'nom'"
			:disabled="!champsTries.length"
			:optionDisabled="(option) => option.libelleGroupe != null">
			<template #option="slotProps">
				<Champ v-if="!slotProps.option.libelleGroupe"
				  :type-objet="typeObjet"
				  :champ="slotProps.option" 
				  :selectionne="selectionSchema.champs.includes(slotProps.option)"
				  @selectionPlageChamps="(champ) => selectionnerPlageChamps(champ)"/>
				<div v-else
					class="groupe-champs">{{ slotProps.option.libelleGroupe }}</div>
			</template>
		</Listbox>
	</div>
</template>

<style scoped>

.liste-champs {
	overflow: auto;
	height: 20vh !important;
	user-select: none;
}

.entete {
	display: flex;
	justify-content: space-between;
	align-items: center;
	margin: 2px;
}

.groupe-champs {
	background-color: rgb(245, 245, 245);
	font-weight: bold;
	margin: 0 !important;
	color: black !important;
}

</style>